import s from "./primitives.module.css";

/** Decorative by construction: `aria-hidden`, because the state it accompanies is announced by the status line
 *  or by the button's `aria-busy`. A spinner that announces itself reads as "loading" over and over. */
export function Spinner({ className }: { className?: string }) {
  return <span className={[s.spinner, className].filter(Boolean).join(" ")} aria-hidden="true" />;
}
